// extracted by css-extract-rspack-plugin
export default {"settlementQuotaConfig":"settlementQuotaConfig-uEamS8","rightTable":"rightTable-ACOTen","rightTableTop":"rightTableTop-vS14AT"};